import React, { useEffect } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Table, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import Paginate from "../components/Paginate";
import {
  listGalleries,
  deleteGallery,
  createGallery,
} from "../actions/galleryActions";
import { GALLERY_CREATE_RESET } from "../constants/galleryConstants";

const GalleryListScreen = ({ history, match }) => {
  const pageNumber = match.params.pageNumber || 1;

  const dispatch = useDispatch();

  const galleryList = useSelector((state) => state.galleryList);
  const { loading, error, galleries, page, pages } = galleryList;

  const galleryDelete = useSelector((state) => state.galleryDelete);
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = galleryDelete;

  /*const galleryCreate = useSelector((state) => state.galleryCreate);
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
    gallery: createdGallery,
  } = galleryCreate;*/

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    dispatch({ type: GALLERY_CREATE_RESET });

    if (!userInfo || !userInfo.isAdmin) {
      history.push("/login");
    }

    // if (successCreate) {
    //   history.push(`/gallery/${createdGallery._id}/edit`);
    // } else {
    dispatch(listGalleries("", pageNumber));
    // }
  }, [
    dispatch,
    history,
    userInfo,
    successDelete,
    // successCreate,
    // createdGallery,
    pageNumber,
  ]);

  const deleteHandler = (id) => {
    if (window.confirm("Are you sure")) {
      dispatch(deleteGallery(id));
    }
  };

  const createGalleryHandler = () => {
    history.push("/galleryadd");
  };

  return (
    <>
      <Row className="align-items-center">
        <Col>
          <h1>Galleries</h1>
        </Col>
        <Col className="text-right">
          <Button className="my-3" onClick={createGalleryHandler}>
            <i className="fas fa-plus"></i> Create Gallery
          </Button>
        </Col>
      </Row>
      {loadingDelete && <Loader />}
      {errorDelete && <Message variant="danger">{errorDelete}</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th>TITLE</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {galleries.map((gallery) => (
                <tr key={gallery._id}>
                  <td>{gallery.title}</td>
                  <td>
                    <LinkContainer to={`/gallery/${gallery._id}`}>
                      <Button variant="success" className="btn-sm">
                        <i className="fas fa-eye"></i>
                      </Button>
                    </LinkContainer>
                    <LinkContainer to={`/gallery/${gallery._id}/gallery`}>
                      <Button variant="info" className="btn-sm">
                        <i className="fas fa-image"></i>
                      </Button>
                    </LinkContainer>
                    <LinkContainer to={`/gallery/${gallery._id}/edit`}>
                      <Button variant="warning" className="btn-sm">
                        <i className="fas fa-edit"></i>
                      </Button>
                    </LinkContainer>
                    <Button
                      variant="danger"
                      className="btn-sm"
                      onClick={() => deleteHandler(gallery._id)}
                    >
                      <i className="fas fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Paginate
            slug="gallerylist"
            pages={pages}
            page={page}
            isAdmin={true}
          />
        </>
      )}
    </>
  );
};

export default GalleryListScreen;
